// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Self-contained styles for the A11y Check results panel.
   No Bootstrap or Tailwind dependency — the panel is rendered in contexts
   (LayoutEditor standalone page, CKEditor windowBridge) where neither
   framework is guaranteed to be present. */

.a11y-panel {
  position: absolute;
  bottom: 16px;
  right: 16px;
  width: 320px;
  max-height: 72vh;
  font-size: 13px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  pointer-events: auto;
  z-index: 9999;

  /* layout */
  display: flex;
  flex-direction: column;

  /* visuals */
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

/* ── Header ──────────────────────────────────────────────────────────── */

.a11y-panel-header {
  padding: 12px 14px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.a11y-panel-score-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 3px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.3s;
}

.a11y-panel-score-value {
  font-size: 11px;
  font-weight: 700;
}

.a11y-panel-scanning-dot {
  font-size: 10px;
  color: #9ca3af;
}

.a11y-panel-meta {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.a11y-panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.a11y-panel-subtitle {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
}

.a11y-panel-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.a11y-panel-action-btn {
  background: none;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
  line-height: 1;
}

.a11y-panel-action-btn:hover:not(:disabled) {
  background: #f9fafb;
}

.a11y-panel-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

/* ── Body ────────────────────────────────────────────────────────────── */

.a11y-panel-body {
  overflow-y: auto;
  padding: 8px 14px;
  flex: 1;
}

.a11y-panel-state {
  text-align: center;
  padding: 24px 0;
  color: #6b7280;
}

.a11y-panel-state--success {
  text-align: center;
  padding: 24px 0;
  color: #16a34a;
  font-weight: 500;
}

.a11y-panel-error {
  padding: 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  color: #dc2626;
  font-size: 12px;
}

.a11y-panel-section-label {
  font-size: 11px;
  font-weight: 600;
  color: #d97706;
  text-transform: uppercase;
  letter-spacing: 0.05ch;
  padding: 10px 0 4px;
}

.a11y-panel-section-label--bordered {
  border-top: 1px solid #e5e7eb;
  margin-top: 4px;
}

.a11y-violations-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* ── Inline stat colours (violations / incomplete / pass counts) ─────── */

.a11y-stat--violations {
  color: #ef4444;
  font-weight: 500;
}

.a11y-stat--review {
  color: #d97706;
  font-weight: 500;
}

.a11y-stat--passed {
  color: #16a34a;
  font-weight: 500;
}

.a11y-stat--error {
  color: #dc2626;
}
`, "",{"version":3,"sources":["webpack://./Scripts/Shared/AccessibilityChecker/styles/A11yResultsPanel.css"],"names":[],"mappings":"AAAA;;;2CAG2C;;AAE3C;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qEAAqE;EACrE,oBAAoB;EACpB,aAAa;;EAEb,WAAW;EACX,aAAa;EACb,sBAAsB;;EAEtB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,2EAA2E;;AAE3E;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA,2EAA2E;;AAE3E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,2EAA2E;;AAE3E;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Self-contained styles for the A11y Check results panel.\r\n   No Bootstrap or Tailwind dependency — the panel is rendered in contexts\r\n   (LayoutEditor standalone page, CKEditor windowBridge) where neither\r\n   framework is guaranteed to be present. */\r\n\r\n.a11y-panel {\r\n  position: absolute;\r\n  bottom: 16px;\r\n  right: 16px;\r\n  width: 320px;\r\n  max-height: 72vh;\r\n  font-size: 13px;\r\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, sans-serif;\r\n  pointer-events: auto;\r\n  z-index: 9999;\r\n\r\n  /* layout */\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  /* visuals */\r\n  background: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* ── Header ──────────────────────────────────────────────────────────── */\r\n\r\n.a11y-panel-header {\r\n  padding: 12px 14px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.a11y-panel-score-circle {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  border: 3px solid;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.a11y-panel-score-value {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n}\r\n\r\n.a11y-panel-scanning-dot {\r\n  font-size: 10px;\r\n  color: #9ca3af;\r\n}\r\n\r\n.a11y-panel-meta {\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.a11y-panel-title {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n}\r\n\r\n.a11y-panel-subtitle {\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  margin-top: 2px;\r\n}\r\n\r\n.a11y-panel-actions {\r\n  display: flex;\r\n  gap: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.a11y-panel-action-btn {\r\n  background: none;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  padding: 4px 8px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  color: #374151;\r\n  line-height: 1;\r\n}\r\n\r\n.a11y-panel-action-btn:hover:not(:disabled) {\r\n  background: #f9fafb;\r\n}\r\n\r\n.a11y-panel-action-btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.45;\r\n}\r\n\r\n/* ── Body ────────────────────────────────────────────────────────────── */\r\n\r\n.a11y-panel-body {\r\n  overflow-y: auto;\r\n  padding: 8px 14px;\r\n  flex: 1;\r\n}\r\n\r\n.a11y-panel-state {\r\n  text-align: center;\r\n  padding: 24px 0;\r\n  color: #6b7280;\r\n}\r\n\r\n.a11y-panel-state--success {\r\n  text-align: center;\r\n  padding: 24px 0;\r\n  color: #16a34a;\r\n  font-weight: 500;\r\n}\r\n\r\n.a11y-panel-error {\r\n  padding: 12px;\r\n  background: #fef2f2;\r\n  border: 1px solid #fecaca;\r\n  border-radius: 6px;\r\n  color: #dc2626;\r\n  font-size: 12px;\r\n}\r\n\r\n.a11y-panel-section-label {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #d97706;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05ch;\r\n  padding: 10px 0 4px;\r\n}\r\n\r\n.a11y-panel-section-label--bordered {\r\n  border-top: 1px solid #e5e7eb;\r\n  margin-top: 4px;\r\n}\r\n\r\n.a11y-violations-list {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n/* ── Inline stat colours (violations / incomplete / pass counts) ─────── */\r\n\r\n.a11y-stat--violations {\r\n  color: #ef4444;\r\n  font-weight: 500;\r\n}\r\n\r\n.a11y-stat--review {\r\n  color: #d97706;\r\n  font-weight: 500;\r\n}\r\n\r\n.a11y-stat--passed {\r\n  color: #16a34a;\r\n  font-weight: 500;\r\n}\r\n\r\n.a11y-stat--error {\r\n  color: #dc2626;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
